export default __webpack_public_path__ + "static/media/d-8.919b1dd2.png";